const feathers = {
	"id":"f00001",
	"name": "Simple outline",
	"description":
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
	"type": "outline",
	"isPremium": false,
	"size": 28,
	"viewBox": 24,
	"cornerRadius": null,
	"preCode": "",
	"postCode": "",
	"disclaimer":"Most of these icons are modified version of the awesome <a target='_blank' href='http://feathericons.com'>Feather icons</a> with several new additions. They are licensed under MIT License - free for personal & commercial use.",
	"content": [
		{
			"title": "Arrows",
			"icons": [
			{
				"name": "arrow-up",
				"code": "<path d=\"M12 19V6M5 12l7-7 7 7\"/>",
				"tags": ["arrow", "up", "above"]
			},
			{
				"name": "arrow-down",
				"code": "<path d=\"M12 5v13M5 12l7 7 7-7\"/>",
				"tags": ["arrow", "down", "below"]
			},
			{
				"name": "arrow-left",
				"code": "<path d=\"M19 12H6M12 5l-7 7 7 7\"/>",
				"tags": ["arrow", "left"]
			},
			{
				"name": "arrow-right",
				"code": "<path d=\"M5 12h13M12 5l7 7-7 7\"/>",
				"tags": ["arrow", "right"]
			},
			{
				"name": "arrow-up-left",
				"code": "<path d=\"M17 17L7.8 7.7M7 17V7h10\"/>",
				"tags": ["arrow", "corner"]
			},
			{
				"name": "arrow-up-right",
				"code": "<path d=\"M7 17l9.2-9.2M17 17V7H7\"/>",
				"tags": ["arrow", "corner"]
			},
			{
				"name": "arrow-down-left",
				"code": "<path d=\"M17 7l-9.2 9.2M7 7v10h10\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "arrow-down-right",
				"code": "<path d=\"M7 7l9.2 9.2M17 7v10H7\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-down-left",
				"code": "<path d=\"M10 9l-6 6 6 6\"/><path d=\"M20 4v7a4 4 0 0 1-4 4H5\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-down-right",
				"code": "<path d=\"M14 9l6 6-6 6\"/><path d=\"M4 4v7a4 4 0 0 0 4 4h11\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-up-left",
				"code": "<path d=\"M10 16l-6-6 6-6\"/><path d=\"M20 21v-7a4 4 0 0 0-4-4H5\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-up-right",
				"code": "<path d=\"M14 16l6-6-6-6\"/><path d=\"M4 21v-7a4 4 0 0 1 4-4h11\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-left-down",
				"code": "<path d=\"M15 14l-6 6-6-6\"/><path d=\"M20 4h-7a4 4 0 0 0-4 4v11\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-left-up",
				"code": "<path d=\"M15 10L9 4l-6 6\"/><path d=\"M20 20h-7a4 4 0 0 1-4-4V5\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-right-down",
				"code": "<path d=\"M9 14l6 6 6-6\"/><path d=\"M4 4h7a4 4 0 0 1 4 4v11\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "corner-right-up",
				"code": "<path d=\"M9 10l6-6 6 6\"/><path d=\"M4 20h7a4 4 0 0 0 4-4V5\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "chevron-down",
				"code": "<path d=\"M6 9l6 6 6-6\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevron-up",
				"code": "<path d=\"M18 15l-6-6-6 6\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevron-left",
				"code": "<path d=\"M15 18l-6-6 6-6\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevron-right",
				"code": "<path d=\"M9 18l6-6-6-6\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevrons-down",
				"code": "<path d=\"M7 13l5 5 5-5M7 6l5 5 5-5\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevrons-left",
				"code": "<path d=\"M11 17l-5-5 5-5M18 17l-5-5 5-5\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevrons-right",
				"code": "<path d=\"M13 17l5-5-5-5M6 17l5-5-5-5\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "chevrons-up",
				"code": "<path d=\"M17 11l-5-5-5 5M17 18l-5-5-5 5\"/>",
				"tags": ["arrow", "chevron"]
			},
			{
				"name": "arrow-up-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M16 12l-4-4-4 4M12 16V9\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "arrow-down-circle",
				"code": " <circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M16 12l-4 4-4-4M12 8v7\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "arrow-right-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 8l4 4-4 4M8 12h7\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "arrow-left-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 8l-4 4 4 4M16 12H9\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "refresh-ccw",
				"code": " <path d=\"M2.5 2v6h6M21.5 22v-6h-6\"/><path d=\"M22 11.5A10 10 0 0 0 3.2 7.2M2 12.5a10 10 0 0 0 18.8 4.2\"/>",
				"tags": ["reload", "repeat", "refresh", "sync"]
			},
			{
				"name": "refresh-cw",
				"code": "<path d=\"M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2\"/>",
				"tags": ["reload", "repeat", "refresh", "sync"]
			},
			{
				"name": "rotate-left",
				"code": "<path d=\"M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38\"/>",
				"tags": ["arrow", "rotate", "reload", "undo"]
			},
			{
				"name": "rotate-right",
				"code": "<path d=\"M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38\"/>",
				"tags": ["arrow", "rotate", "reload", "redo"]
			},
			{
				"name": "repeat",
				"code": "<path d=\"M17 2.1l4 4-4 4\"/><path d=\"M3 12.2v-2a4 4 0 0 1 4-4h12.8M7 21.9l-4-4 4-4\"/><path d=\"M21 11.8v2a4 4 0 0 1-4 4H4.2\"/>",
				"tags": ["reload", "repeat", "refresh"]
			},
			{
				"name": "arrow-in",
				"code": "<path d=\"M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3\"/>",
				"tags": ["arrow", "login", "right"]
			},
			{
				"name": "arrow-in-square",
				"code": "<path d=\"M15 3h6v18h-6M10 17l5-5-5-5M13.8 12H3\"/>",
				"tags": ["arrow", "login", "right"]
			},
			{
				"name": "arrow-in-circle",
				"code": "<path d=\"M10 17l5-5-5-5\"/><path d=\"M13.8 12H3m9 10a10 10 0 1 0 0-20\"/>",
				"tags": ["arrow"]
			},
			{
				"name": "arrow-out",
				"code": "<path d=\"M10 3H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4M16 17l5-5-5-5M19.8 12H9\"/>",
				"tags": ["arrow", "exit", "logout"]
			},
			{
				"name": "arrow-out-square",
				"code": "<path d=\"M16 17l5-5-5-5M19.8 12H9M10 3H4v18h6\"/>",
				"tags": ["arrow", "exit", "logout"]
			},
			{
				"name": "arrow-out-circle",
				"code": "<path d=\"M16 17l5-5-5-5M19.8 12H9M13 22a10 10 0 1 1 0-20\"/>",
				"tags": ["arrow", "exit", "logout"]
			},
			{
				"name": "upload",
				"code": "<path d=\"M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 8l-5-5-5 5M12 4.2v10.3\"/>",
				"tags": ["arrow", "upload", "share", "up"]
			},
			{
				"name": "download",
				"code": "<path d=\"M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5\"/>",
				"tags": ["arrow", "download", "down", "into"]
			},
			{
				"name": "upload-cloud",
				"code": "<path d=\"M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21\"/><path d=\"M16 16l-4-4-4 4\"/>",
				"tags": ["arrow", "cloud", "upload", "sync"]
			},
			{
				"name": "download-cloud",
				"code": "<path d=\"M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8M12 19.8V12M16 17l-4 4-4-4\"/>",
				"tags": ["arrow", "cloud", "download", "sync"]
			},
			{
				"name": "minimize",
				"code": "<path d=\"M4 14h6v6M3 21l6.1-6.1M20 10h-6V4M21 3l-6.1 6.1\"/>",
				"tags": ["shrink", "resize"]
			},
			{
				"name": "maximize",
				"code": "<path d=\"M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1\"/>",
				"tags": ["enlarge", "resize"]
			},
			{
				"name": "trending-down",
				"code": "<path d=\"M20.2 17.2l-7.7-7.7-4 4-5.7-5.7\"/><path d=\"M15 18h6v-6\"/>",
				"tags": ["arrow", "graph", "chart"]
			},
			{
				"name": "trending-up",
				"code": "<path d=\"M20.2 7.8l-7.7 7.7-4-4-5.7 5.7\"/><path d=\"M15 7h6v6\"/>",
				"tags": ["arrow", "graph", "chart"]
			},
			{
				"name": "shuffle",
				"code": "<path d=\"M16 3h5v5M4 20L20.2 3.8M21 16v5h-5M15 15l5.1 5.1M4 4l5 5\"/>",
				"tags": ["arrow", "cross"]
			},
			{
				"name": "move",
				"code": "<path d=\"M5.2 9l-3 3 3 3M9 5.2l3-3 3 3M15 18.9l-3 3-3-3M18.9 9l3 3-3 3M3.3 12h17.4M12 3.2v17.6\"/>",
				"tags": ["arrow", "drag"]
			},
			{
				"name": "expand",
				"code": "<path d=\"M3.8 3.8l16.4 16.4M20.2 3.8L3.8 20.2M15 3h6v6M9 3H3v6M15 21h6v-6M9 21H3v-6\"/>",
				"tags": ["arrow", "maximize", "enlarge"]
			},
			{
				"name": "external-link",
				"code": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8\"/></g>",
				"tags": ["arrow", "share", "out"]
			}]
		},
		{
			"title": "Interface",
			"icons": [
			{
				"name": "menu",
				"code": "<line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"3\" y1=\"18\" x2=\"21\" y2=\"18\"></line>",
				"tags": ["menu", "hamburger", "navigation", "stripes"]
			},
			{
				"name": "grid",
				"code": "<rect x=\"3\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\"></rect>",
				"tags": ["menu", "layout", "grid"]
			},
			{
				"name": "loader",
				"code": "<line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"6\"></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"22\"></line><line x1=\"4.93\" y1=\"4.93\" x2=\"7.76\" y2=\"7.76\"></line><line x1=\"16.24\" y1=\"16.24\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"2\" y1=\"12\" x2=\"6\" y2=\"12\"></line><line x1=\"18\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"7.76\" y2=\"16.24\"></line><line x1=\"16.24\" y1=\"7.76\" x2=\"19.07\" y2=\"4.93\"></line>",
				"tags": ["loader", "loading", "spinner"]
			},
			{
				"name": "alert-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"></line>",
				"tags": ["alert", "error", "warning"]
			},
			{
				"name": "alert-octagon",
				"code": "<polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"></line>",
				"tags": ["alert", "error", "warning"]
			},
			{
				"name": "alert-triangle",
				"code": "<path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\"></line><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\"></line>",
				"tags": ["alert", "error", "warning"]
			},
			{
				"name": "help-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3\"></path><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\"></line>",
				"tags": ["alert", "help", "support", "question"]
			},
			{
				"name": "info",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12.01\" y2=\"8\"></line>",
				"tags": ["alert", "info", "about"]
			},
			{
				"name": "hexagon",
				"code": "<path d=\"M12 2l9 4.9V17L12 22l-9-4.9V7z\"/>",
				"tags": ["shape"]
			},
			{
				"name": "octagon",
				"code": "<polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon>",
				"tags": ["shape"]
			},
			{
				"name": "triangle",
				"code": "<path d=\"M3 20h18L12 4z\"/>",
				"tags": ["shape", "sharp", "alert"]
			},
			{
				"name": "circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle>",
				"tags": ["shape", "alert", "round", "egg"]
			},
			{
				"name": "square",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect>",
				"tags": ["shape", "box", "square"]
			},
			{
				"name": "plus",
				"code": "<line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"></line><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>",
				"tags": ["add", "plus", "cross"]
			},
			{
				"name": "minus",
				"code": "<line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>",
				"tags": ["negative", "minues", "dash"]
			},
			{
				"name": "x",
				"code": "<line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"></line><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"></line>",
				"tags": ["close", "delete", "wrong", "incorrect", "remove", "clear"]
			},
			{
				"name": "plus-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
				"tags": ["add", "plus", "cross"]
			},
			{
				"name": "minus-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>",
				"tags": ["negative", "minues", "dash"]
			},
			{
				"name": "x-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line>",
				"tags": ["close", "delete", "wrong", "incorrect", "remove", "clear"]
			},
			{
				"name": "plus-square",
				"code": "<path d=\"M3 3h18v18H3zM12 8v8m-4-4h8\"/>",
				"tags": ["add", "plus", "cross"]
			},
			{
				"name": "minus-square",
				"code": "<path d=\"M3 3h18v18H3zM8 12h8\"/>",
				"tags": ["negative", "minues", "dash"]
			},
			{
				"name": "x-square",
				"code": "<path d=\"M3 3h18v18H3zM15 9l-6 6m0-6l6 6\"/>",
				"tags": ["close", "delete", "wrong", "incorrect", "remove", "clear"]
			},
			{
				"name": "check-circle",
				"code": "<path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\"></path><polyline points=\"22 4 12 14.01 9 11.01\"></polyline>",
				"tags": ["tick", "check", "correct", "ok"]
			},
			{
				"name": "check-square",
				"code": "<polyline points=\"9 11 12 14 22 4\"></polyline><path d=\"M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11\"></path>",
				"tags": ["tick", "check", "correct", "ok"]
			},
			{
				"name": "check",
				"code": "<polyline points=\"20 6 9 17 4 12\"></polyline>",
				"tags": ["tick", "check", "correct", "ok"]
			},
			{
				"name": "slash",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"19.07\" y2=\"19.07\"></line>",
				"tags": ["no", "block", "remove", "cannot"]
			},
			{
				"name": "more-horizontal",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"19\" cy=\"12\" r=\"1\"></circle><circle cx=\"5\" cy=\"12\" r=\"1\"></circle>",
				"tags": ["dots", "more", "context", "kebab"]
			},
			{
				"name": "more-vertical",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"12\" cy=\"5\" r=\"1\"></circle><circle cx=\"12\" cy=\"19\" r=\"1\"></circle>",
				"tags": ["dots", "more", "context", "kebab"]
			},
			{
				"name": "edit",
				"code": "<path d=\"M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34\"></path><polygon points=\"18 2 22 6 12 16 8 16 8 12 18 2\"></polygon>",
				"tags": ["pencil", "edit", "change", "form", "new", "write"]
			},
			{
				"name": "edit-2",
				"code": "<polygon points=\"16 3 21 8 8 21 3 21 3 16 16 3\"></polygon>",
				"tags": ["pencil", "edit", "change", "form", "new", "write"]
			},
			{
				"name": "edit-3",
				"code": "<polygon points=\"14 2 18 6 7 17 3 17 3 13 14 2\"></polygon><line x1=\"3\" y1=\"22\" x2=\"21\" y2=\"22\"></line>",
				"tags": ["pencil", "edit", "change", "form", "new", "write"]
			},
			{
				"name": "settings",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"3\"></circle><path d=\"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z\"></path>",
				"tags": ["cog", "preferences"]
			},
			{
				"name": "sliders",
				"code": "<line x1=\"4\" y1=\"21\" x2=\"4\" y2=\"14\"></line><line x1=\"4\" y1=\"10\" x2=\"4\" y2=\"3\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"3\"></line><line x1=\"20\" y1=\"21\" x2=\"20\" y2=\"16\"></line><line x1=\"20\" y1=\"12\" x2=\"20\" y2=\"3\"></line><line x1=\"1\" y1=\"14\" x2=\"7\" y2=\"14\"></line><line x1=\"9\" y1=\"8\" x2=\"15\" y2=\"8\"></line><line x1=\"17\" y1=\"16\" x2=\"23\" y2=\"16\"></line>",
				"tags": ["settings", "filter", "preferences", "range"]
			},
			{
				"name": "search",
				"code": "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line>",
				"tags": ["find", "magnifying", "search", "zoom"]
			},
			{
				"name": "zoom-in",
				"code": "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"11\" y1=\"8\" x2=\"11\" y2=\"14\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>",
				"tags": ["search", "magnifying", "plus"]
			},
			{
				"name": "zoom-out",
				"code": "<circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>",
				"tags": ["search", "magnifying", "minus"]
			},
			{
				"name": "share",
				"code": "<circle cx=\"18\" cy=\"5\" r=\"3\"></circle><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"19\" r=\"3\"></circle><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"></line><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"></line>",
				"tags": ["share"]
			},
			{
				"name": "clock",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 6 12 12 16 14\"></polyline>",
				"tags": ["time", "date", "watch", "later", "history"]
			},
			{
				"name": "eye",
				"code": "<path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\"></path><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>",
				"tags": ["look", "visible", "show", "see"]
			},
			{
				"name": "star",
				"code": "<polygon points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon>",
				"tags": ["rating", "rate", "star", "like", "wishlist"]
			},
			{
				"name": "heart",
				"code": "<path d=\"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z\"></path>",
				"tags": ["love", "heart", "like", "wishlist"]
			},
			{
				"name": "flag",
				"code": "<path d=\"M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z\"></path><line x1=\"4\" y1=\"22\" x2=\"4\" y2=\"15\"></line>",
				"tags": ["report", "flag", "country"]
			},
			{
				"name": "bookmark",
				"code": "<path d=\"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z\"></path>",
				"tags": ["wishlist", "save", "later"]
			},
			{
				"name": "message-circle",
				"code": "<path d=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"></path>",
				"tags": [
					"chat",
					"message",
					"talk",
					"bubble",
					"speak",
					"comment",
					"review"
				]
			},
			{
				"name": "message-square",
				"code": "<path d=\"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z\"></path>",
				"tags": [
					"chat",
					"message",
					"talk",
					"bubble",
					"speak",
					"comment",
					"review"
				]
			},
			{
				"name": "trash",
				"code": "<polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\"></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\"></line>",
				"tags": ["dustbin", "delete", "remove", "clear", "garbage"]
			},
			{
				"name": "moon",
				"code": "<path d=\"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z\"></path>",
				"tags": ["dark", "night", "crescent"]
			},
			{
				"name": "sun",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"5\"/><path d=\"M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4\"/>",
				"tags": ["light", "dat", "shone"]
			},
			{
				"name": "thumbs-down",
				"code": "<path d=\"M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17\"></path>",
				"tags": ["vote", "down", "thumbs", "hand"]
			},
			{
				"name": "thumbs-up",
				"code": "<path d=\"M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3\"></path>",
				"tags": ["vote", "up", "thumbs", "hand"]
			},
			{
				"name": "maximize-2",
				"code": "<path d=\"M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3\"></path>",
				"tags": [""]
			},
			{
				"name": "minimize-3",
				"code": "<path d=\"M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3\"></path>",
				"tags": [""]
			},
			{
				"name": "bell",
				"code": "<path d=\"M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0\"></path>",
				"tags": ["notification", "announcement", "alarm"]
			},
			{
				"name": "mail",
				"code": "<path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"></path><polyline points=\"22,6 12,13 2,6\"></polyline>",
				"tags": ["email", "envelope", "letter"]
			},
			{
				"name": "calendar",
				"code": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line>",
				"tags": ["date"]
			},
			{
				"name": "lock",
				"code": "<rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"></path>",
				"tags": ["key", "private", "login"]
			},
			{
				"name": "unlock",
				"code": "<rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 9.9-1\"></path>",
				"tags": ["key"]
			},
			{
				"name": "shopping-bag",
				"code": "<path d=\"M6 2L3 6v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6l-3-4H6zM3.8 6h16.4M16 10a4 4 0 1 1-8 0\"/>",
				"tags": ["commerce", "cart", "ecommerce"]
			},
			{
				"name": "shopping-cart",
				"code": "<circle cx=\"10\" cy=\"20.5\" r=\"1\"/><circle cx=\"18\" cy=\"20.5\" r=\"1\"/><path d=\"M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1\"/>",
				"tags": ["commerce", "ecommerce"]
			},
			{
				"name": "tag",
				"code": "<path d=\"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z\"></path><line x1=\"7\" y1=\"7\" x2=\"7.01\" y2=\"7\"></line>",
				"tags": ["tag", "coupon", "promo", "discount"]
			},
			{
				"name": "map-marker-1",
				"code": "<path d=\"M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z\"/><circle cx=\"12\" cy=\"10\" r=\"3\"/>",
				"tags": ["pin", "location"]
			},
			{
				"name": "map-marker-2",
				"code": "<circle cx=\"12\" cy=\"10\" r=\"3\"/><path d=\"M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z\"/>",
				"tags": ["pin", "location"]
			},
			{
				"name": "map-marker-3",
				"code": "<circle cx=\"11.5\" cy=\"8.5\" r=\"5.5\"/><path d=\"M11.5 14v7\"/>",
				"tags": ["pin", "location"]
			},
			{
				"name": "compass",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M16.2 7.8l-2 6.3-6.4 2.1 2-6.3z\"/>",
				"tags": ["compass", "direction", "location"]
			},
			{
				"name": "home",
				"code": "<path d=\"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\"></path><polyline points=\"9 22 9 12 15 12 15 22\"></polyline>",
				"tags": ["home", "house", "building"]
			},
			{
				"name": "home-2",
				"code": "<path d=\"M20 9v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9\"/><path d=\"M9 22V12h6v10M2 10.6L12 2l10 8.6\"/>",
				"tags": ["home", "house", "building"]
			},
			{
				"name": "inbox",
				"code": "<path d=\"M21.5 12H16c-.7 2-2 3-4 3s-3.3-1-4-3H2.5\"/><path d=\"M5.5 5.1L2 12v6c0 1.1.9 2 2 2h16a2 2 0 002-2v-6l-3.4-6.9A2 2 0 0016.8 4H7.2a2 2 0 00-1.8 1.1z\"/>",
				"tags": ["inbox", "mail"]
			},
			{
				"name": "credit-card",
				"code": "<rect x=\"2\" y=\"4\" width=\"20\" height=\"16\" rx=\"2\"/><path d=\"M7 15h0M2 9.5h20\"/>",
				"tags": ["payment", "card",]
			}]
		},
		{
			"title": "Medias",
			"icons": [
			{
				"name": "play",
				"code": "<polygon points=\"5 3 19 12 5 21 5 3\"></polygon>",
				"tags": ["triangle"]
			},
			{
				"name": "pause",
				"code": "<rect x=\"6\" y=\"4\" width=\"4\" height=\"16\"></rect><rect x=\"14\" y=\"4\" width=\"4\" height=\"16\"></rect>",
				"tags": [""]
			},
			{
				"name": "play-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polygon points=\"10 8 16 12 10 16 10 8\"></polygon>",
				"tags": [""]
			},
			{
				"name": "pause-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"10\" y1=\"15\" x2=\"10\" y2=\"9\"></line><line x1=\"14\" y1=\"15\" x2=\"14\" y2=\"9\"></line>",
				"tags": [""]
			},
			{
				"name": "stop-circle",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect>",
				"tags": [""]
			},
			{
				"name": "rewind",
				"code": "<polygon points=\"11 19 2 12 11 5 11 19\"></polygon><polygon points=\"22 19 13 12 22 5 22 19\"></polygon>",
				"tags": ["back", "previous"]
			},
			{
				"name": "fast-forward",
				"code": "<polygon points=\"13 19 22 12 13 5 13 19\"></polygon><polygon points=\"2 19 11 12 2 5 2 19\"></polygon>",
				"tags": ["forward", "next"]
			},
			{
				"name": "skip-back",
				"code": "<polygon points=\"19 20 9 12 19 4 19 20\"></polygon><line x1=\"5\" y1=\"19\" x2=\"5\" y2=\"5\"></line>",
				"tags": ["back", "previous"]
			},
			{
				"name": "skip-forward",
				"code": "<polygon points=\"5 4 15 12 5 20 5 4\"></polygon><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"19\"></line>",
				"tags": ["forward", "next"]
			},
			{
				"name": "volume-2",
				"code": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07\"></path>",
				"tags": ["speaker", "sound", "music"]
			},
			{
				"name": "volume-1",
				"code": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M15.54 8.46a5 5 0 0 1 0 7.07\"></path>",
				"tags": ["speaker", "sound", "music"]
			},
			{
				"name": "volume-x",
				"code": "<path d=\"M11 5L6 9H2v6h4l5 4zM22 9l-6 6M16 9l6 6\"/>",
				"tags": ["speaker", "sound", "music", "mute"]
			},
			{
				"name": "volume",
				"code": "<polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon>",
				"tags": [""]
			},
			{
				"name": "music",
				"code": "<circle cx=\"5.5\" cy=\"17.5\" r=\"2.5\"/><circle cx=\"17.5\" cy=\"15.5\" r=\"2.5\"/><path d=\"M8 17V5l12-2v12\"/>",
				"tags": ["note"]
			},
			{
				"name": "video-off",
				"code": "<path d=\"M2 2l19.8 19.8M15 15.7V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h.3m5.4 0H13a2 2 0 0 1 2 2v3.3l1 1L22 7v10\"/>",
				"tags": ["camera", "no video"]
			},
			{
				"name": "video",
				"code": "<path d=\"M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z\"/>",
				"tags": ["camera"]
			},
			{
				"name": "camera",
				"code": "<g transform=\"translate(2 3)\"><path d=\"M20 16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3l2-3h6l2 3h3a2 2 0 0 1 2 2v11z\"/><circle cx=\"10\" cy=\"10\" r=\"4\"/></g>",
				"tags": ["photo", "snap", "picture"]
			},
			{
				"name": "mic",
				"code": "<path d=\"M12 2c-1.7 0-3 1.2-3 2.6v6.8c0 1.4 1.3 2.6 3 2.6s3-1.2 3-2.6V4.6C15 3.2 13.7 2 12 2z\"/><path d=\"M19 10v1a7 7 0 0 1-14 0v-1M12 18.4v3.3M8 22h8\"/>",
				"tags": ["microphone", "record", "voice"]
			},
			{
				"name": "film",
				"code": "<rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"2.18\" ry=\"2.18\"></rect><line x1=\"7\" y1=\"2\" x2=\"7\" y2=\"22\"></line><line x1=\"17\" y1=\"2\" x2=\"17\" y2=\"22\"></line><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"2\" y1=\"7\" x2=\"7\" y2=\"7\"></line><line x1=\"2\" y1=\"17\" x2=\"7\" y2=\"17\"></line><line x1=\"17\" y1=\"17\" x2=\"22\" y2=\"17\"></line><line x1=\"17\" y1=\"7\" x2=\"22\" y2=\"7\"></line>",
				"tags": ["video", "strip"]
			},
			{
				"name": "image",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"/><path d=\"M20.4 14.5L16 10 4 20\"/>",
				"tags": ["photo", "picture", "image", "photograph"]
			},
			{
				"name": "radio",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"2\"></circle><path d=\"M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14\"></path>",
				"tags": ["wave", "podcast", "signal", "sound"]
			}]
		},
		{
			"title": "Files & folders",
			"icons": [
			{
				"name": "file",
				"code": "<path d=\"M13 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V9l-7-7z\"/><path d=\"M13 3v6h6\"/>",
				"tags": ["file", "paper", "document"]
			},
			{
				"name": "file-text",
				"code": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z\"/><path d=\"M14 3v5h5M16 13H8M16 17H8M10 9H8\"/>",
				"tags": ["file", "paper", "document", "article"]
			},
			{
				"name": "file-plus",
				"code": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z\"/><path d=\"M14 3v5h5M12 18v-6M9 15h6\"/>",
				"tags": ["file", "paper", "document", "add", "plus", "new"]
			},
			{
				"name": "file-minus",
				"code": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z\"/><path d=\"M14 3v5h5M9 15h6\"/>",
				"tags": ["file", "paper", "document", "minus", "remove"]
			},
			{
				"name": "file-x",
				"code": "<path d=\"M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z\"/><path d=\"M14 3v5h5M9.9 17.1L14 13M9.9 12.9L14 17\"/>",
				"tags": ["file", "paper", "document", "remove", "delete"]
			},
			{
				"name": "file-plus-2",
				"code": "<path d=\"M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6\"/><path d=\"M14 3v5h5M18 21v-6M15 18h6\"/>",
				"tags": ["file", "paper", "document", "add", "plus", "new"]
			},
			{
				"name": "file-minus-2",
				"code": "<path d=\"M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6\"/><path d=\"M14 3v5h5M15 18h6\"/>",
				"tags": ["file", "paper", "document", "minus", "remove"]
			},
			{
				"name": "file-x-2",
				"code": "<path d=\"M20 11.08V8l-6-6H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h6\"/><path d=\"M14 3v5h5M15.88 20.12l4.24-4.24M15.88 15.88l4.24 4.24\"/>",
				"tags": ["file", "paper", "document", "remove", "delete"]
			},
			{
				"name": "folder",
				"code": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path>",
				"tags": ["folder", "directory"]
			},
			{
				"name": "folder-plus",
				"code": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"12\" y1=\"11\" x2=\"12\" y2=\"17\"></line><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>",
				"tags": ["folder", "directory", "add", "plus", "new"]
			},
			{
				"name": "folder-minus",
				"code": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>",
				"tags": ["folder", "directory", "minus", "remove"]
			},
			{
				"name": "folder-x",
				"code": "<path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h5l2 3h9a2 2 0 0 1 2 2v11zM9.9 16.1L14 12M9.9 11.9L14 16\"/>",
				"tags": ["folder", "directory", "minus", "remove", "delete"]
			},
			{
				"name": "folder-plus-2",
				"code": "<path d=\"M11 21H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h5l2 3h9a2 2 0 0 1 2 2v2M19 15v6M16 18h6\"/>",
				"tags": ["folder", "directory", "add", "plus", "new"]
			},
			{
				"name": "folder-minus-2",
				"code": "<path d=\"M11 21H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h5l2 3h9a2 2 0 0 1 2 2v2M16 18h6\"/>",
				"tags": ["folder", "directory", "minus", "remove"]
			},
			{
				"name": "folder-x-2",
				"code": "<path d=\"M11 21H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h5l2 3h9a2 2 0 0 1 2 2v2M21.12 15.88l-4.24 4.24M16.88 15.88l4.24 4.24\"/>",
				"tags": ["folder", "directory", "minus", "remove", "delete"]
			}]
		},
		{
			"title": "Editor",
			"icons": [
			{
				"name": "bold",
				"code": "<path d=\"M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path><path d=\"M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path>",
				"tags": ["format"]
			},
			{
				"name": "underline",
				"code": "<path d=\"M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3\"></path><line x1=\"4\" y1=\"21\" x2=\"20\" y2=\"21\"></line>",
				"tags": ["format"]
			},
			{
				"name": "italic",
				"code": "<path d=\"M19 4h-9M14 20H5M14.7 4.7L9.2 19.4\"/>",
				"tags": ["format", "slanted"]
			},
			{
				"name": "strikethrough",
				"code": "<path d=\"M17.3 4.9c-2.3-.6-4.4-1-6.2-.9-2.7 0-5.3.7-5.3 3.6 0 1.5 1.8 3.3 3.6 3.9h.2m8.2 3.7c.3.4.4.8.4 1.3 0 2.9-2.7 3.6-6.2 3.6-2.3 0-4.4-.3-6.2-.9M4 11.5h16\"/>",
				"tags": ["cancel", "strike"]
			},
			{
				"name": "type",
				"code": "<polyline points=\"4 7 4 4 20 4 20 7\"></polyline><line x1=\"9\" y1=\"20\" x2=\"15\" y2=\"20\"></line><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"20\"></line>",
				"tags": ["font", "typeface", "text", "letter"]
			},
			{
				"name": "align-left",
				"code": "<path d=\"M17 9.5H3M21 4.5H3M21 14.5H3M17 19.5H3\"/>",
				"tags": ["alignment", "text"]
			},
			{
				"name": "align-center",
				"code": "<path d=\"M19 9.5H5M21 4.5H3M21 14.5H3M19 19.5H5\"/>",
				"tags": ["alignment", "text"]
			},
			{
				"name": "align-right",
				"code": "<path d=\"M21 9.5H7M21 4.5H3M21 14.5H3M21 19.5H7\"/>",
				"tags": ["alignment", "text"]
			},
			{
				"name": "align-justify",
				"code": "<path d=\"M21 9.5H3M21 4.5H3M21 14.5H3M21 19.5H3\"/>",
				"tags": ["alignment", "text", "lines"]
			},
			{
				"name": "table",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M21 12H3M12 3v18\"/>",
				"tags": ["grid", "block"]
			},
			{
				"name": "table-2",
				"code": "<path d=\"M3 3h18v18H3zM21 9H3M21 15H3M12 3v18\"/>",
				"tags": ["grid", "block"]
			},
			{
				"name": "list",
				"code": "<line x1=\"8\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"8\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"8\" y1=\"18\" x2=\"21\" y2=\"18\"></line><line x1=\"3\" y1=\"6\" x2=\"3.01\" y2=\"6\"></line><line x1=\"3\" y1=\"12\" x2=\"3.01\" y2=\"12\"></line><line x1=\"3\" y1=\"18\" x2=\"3.01\" y2=\"18\"></line>",
				"tags": ["bullet", "items", "todo"]
			},
			{
				"name": "save",
				"code": "<path d=\"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z\"></path><polyline points=\"17 21 17 13 7 13 7 21\"></polyline><polyline points=\"7 3 7 8 15 8\"></polyline>",
				"tags": [""]
			},
			{
				"name": "scissors",
				"code": "<circle cx=\"6\" cy=\"6\" r=\"3\"></circle><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><line x1=\"20\" y1=\"4\" x2=\"8.12\" y2=\"15.88\"></line><line x1=\"14.47\" y1=\"14.48\" x2=\"20\" y2=\"20\"></line><line x1=\"8.12\" y1=\"8.12\" x2=\"12\" y2=\"12\"></line>",
				"tags": ["cut", "tool"]
			},
			{
				"name": "copy",
				"code": "<rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path>",
				"tags": ["duplicate"]
			},
			{
				"name": "clipboard",
				"code": "<path d=\"M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2\"></path><rect x=\"8\" y=\"2\" width=\"8\" height=\"4\" rx=\"1\" ry=\"1\"></rect>",
				"tags": ["copy", "paste"]
			},
			{
				"name": "code",
				"code": "<polyline points=\"16 18 22 12 16 6\"></polyline><polyline points=\"8 6 2 12 8 18\"></polyline>",
				"tags": [""]
			},
			{
				"name": "link",
				"code": "<path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path>",
				"tags": ["chain", "hyperlink"]
			},
			{
				"name": "paperclip",
				"code": "<path d=\"M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48\"></path>",
				"tags": ["attachment", "file", "clippy"]
			},
			{
				"name": "delete",
				"code": "<path d=\"M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z\"></path><line x1=\"18\" y1=\"9\" x2=\"12\" y2=\"15\"></line><line x1=\"12\" y1=\"9\" x2=\"18\" y2=\"15\"></line>",
				"tags": ["remove", "clear", "backspace"]
			}]
		},
		{
			"title": "Symbols and shapes",
			"icons": [
			{
				"name": "at-sign",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"4\"></circle><path d=\"M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94\"></path>",
				"tags": ["alias", "email", "handle"]
			},
			{
				"name": "percent",
				"code": "<line x1=\"19\" y1=\"5\" x2=\"5\" y2=\"19\"></line><circle cx=\"6.5\" cy=\"6.5\" r=\"2.5\"></circle><circle cx=\"17.5\" cy=\"17.5\" r=\"2.5\"></circle>",
				"tags": ["discount", "sale", "promotion"]
			},
			{
				"name": "dollar-sign",
				"code": "<line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"23\"></line><path d=\"M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6\"></path>",
				"tags": ["money", "currency", "cash"]
			},
			{
				"name": "bluetooth",
				"code": "<polyline points=\"6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5\"></polyline>",
				"tags": [""]
			},
			{
				"name": "hash",
				"code": "<line x1=\"4\" y1=\"9\" x2=\"20\" y2=\"9\"></line><line x1=\"4\" y1=\"15\" x2=\"20\" y2=\"15\"></line><line x1=\"10\" y1=\"3\" x2=\"8\" y2=\"21\"></line><line x1=\"16\" y1=\"3\" x2=\"14\" y2=\"21\"></line>",
				"tags": ["hashtag"]
			},
			{
				"name": "power",
				"code": "<path d=\"M18.36 6.64a9 9 0 1 1-12.73 0\"></path><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"12\"></line>",
				"tags": ["on", "off", "shutdown"]
			},
			{
				"name": "command",
				"code": "<path d=\"M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z\"></path>",
				"tags": ["cmd", "control"]
			},
			{
				"name": "rss",
				"code": "<path d=\"M4 11a9 9 0 0 1 9 9\"></path><path d=\"M4 4a16 16 0 0 1 16 16\"></path><circle cx=\"5\" cy=\"19\" r=\"1\"></circle>",
				"tags": ["feed"]
			},
			{
				"name": "airplay",
				"code": "<path d=\"M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1\"></path><polygon points=\"12 15 17 21 7 21 12 15\"></polygon>",
				"tags": [""]
			},
			{
				"name": "cast",
				"code": "<path d=\"M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6\"></path><line x1=\"2\" y1=\"20\" x2=\"2.01\" y2=\"20\"></line>",
				"tags": ["google", "chromecast"]
			},
			{
				"name": "wifi",
				"code": "<path d=\"M5 12.55a11 11 0 0 1 14.08 0\"></path><path d=\"M1.42 9a16 16 0 0 1 21.16 0\"></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\"></path><line x1=\"12\" y1=\"20\" x2=\"12.01\" y2=\"20\"></line>",
				"tags": ["wifi", "wireless", "signal"]
			}]
		},

		{
			"title": "Users",
			"icons": [
			{
				"name": "user",
				"code": "<path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"></path><circle cx=\"12\" cy=\"7\" r=\"4\"></circle>",
				"tags": ["user", "people"]
			},
			{
				"name": "user-check",
				"code": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><polyline points=\"17 11 19 13 23 9\"></polyline>",
				"tags": ["user", "people", "check", "tick"]
			},
			{
				"name": "user-minus",
				"code": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>",
				"tags": ["user", "people", "minus"]
			},
			{
				"name": "user-plus",
				"code": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"20\" y1=\"8\" x2=\"20\" y2=\"14\"></line><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>",
				"tags": ["user", "people", "check", "tick"]
			},
			{
				"name": "user-x",
				"code": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\"></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\"></line>",
				"tags": ["user", "people", "delete", "remove"]
			},
			{
				"name": "users",
				"code": "<path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path>",
				"tags": ["user", "people", "group", "friends"]
			},
			{
				"name": "user-circle",
				"code": "<path d=\"M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3\"/><circle cx=\"12\" cy=\"10\" r=\"3\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/>",
				"tags": ["user", "people"]
			}]
		},
		{
			"title": "Graphs & charts",
			"icons": [
			{
				"name": "bar-chart",
				"code": "<line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"10\"></line><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"16\"></line>",
				"tags": ["chart", "graph", "data"]
			},
			{
				"name": "bar-chart-2",
				"code": "<line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\"></line><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\"></line>",
				"tags": ["chart", "graph", "data"]
			},
			{
				"name": "bar-chart-3",
				"code": "<path d=\"M12 20V10M6 20V4M18 20v-4\"/>",
				"tags": ["chart", "graph", "data"]
			},
			{
				"name": "bar-chart-4",
				"code": "<path d=\"M12 20v-6M6 20V10M18 20V4\"/>",
				"tags": ["chart", "graph", "data"]
			},
			{
				"name": "pie-chart",
				"code": "<path d=\"M21.21 15.89A10 10 0 1 1 8 2.83\"></path><path d=\"M22 12A10 10 0 0 0 12 2v10z\"></path>",
				"tags": ["chart", "data", "pie"]
			},
			{
				"name": "pie-chart-2",
				"code": "<path d=\"M12 2a10 10 0 1 0 10 10H12V2zM21.18 8.02c-1-2.3-2.85-4.17-5.16-5.18\"/>",
				"tags": ["chart", "data", "pie"]
			},
			{
				"name": "pie-chart-3",
				"code": "<path d=\"M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z\"/><path d=\"M19 6l-7 6V2.5\"/>",
				"tags": ["chart", "data", "pie"]
			},
			{
				"name": "pie-chart-4",
				"code": "<path d=\"M21.5 12H12V2.5\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/>",
				"tags": ["chart", "data", "pie"]
			},
			{
				"name": "pie-chart-5",
				"code": "<path d=\"M18.6 18.6L12 12V2.5\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/>",
				"tags": ["chart", "data", "pie"]
			},
			{
				"name": "line-chart",
				"code": "<path d=\"M3 3v18h18\"/><path d=\"M18.7 8l-5.1 5.2-2.8-2.7L7 14.3\"/>",
				"tags": ["chart", "data", "line"]
			},
			{
				"name": "line-chart-2",
				"code": "<path d=\"M3 3v18h18\"/><path d=\"M18.7 14.3L15 10.5l-2.7 2.7L7 8\"/>",
				"tags": ["chart", "data", "line"]
			}]
		},
		{
			"title": "Devices",
			"icons": [
			{
				"name": "monitor",
				"code": "<rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"21\"></line>",
				"tags": ["screen", "computer"]
			},
			{
				"name": "smartphone",
				"code": "<rect x=\"5\" y=\"2\" width=\"14\" height=\"20\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"></line>",
				"tags": ["iphone", "phone"]
			},
			{
				"name": "tablet",
				"code": "<rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\" \/><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\" \/>",
				"tags": ["ipad", "tablet"]
			},
			{
				"name": "speaker",
				"code": "<rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\"></rect><circle cx=\"12\" cy=\"14\" r=\"4\"></circle><line x1=\"12\" y1=\"6\" x2=\"12.01\" y2=\"6\"></line>",
				"tags": ["sound", "music"]
			},
			{
				"name": "headphones",
				"code": "<path d=\"M3 18v-6a9 9 0 0 1 18 0v6\"></path><path d=\"M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z\"></path>",
				"tags": [""]
			},
			{
				"name": "tv",
				"code": "<rect x=\"2\" y=\"7\" width=\"20\" height=\"15\" rx=\"2\" ry=\"2\"></rect><polyline points=\"17 2 12 7 7 2\"></polyline>",
				"tags": [""]
			},
			{
				"name": "watch",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"7\"></circle><polyline points=\"12 9 12 12 13.5 13.5\"></polyline><path d=\"M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83\"></path>",
				"tags": [""]
			},
			{
				"name": "hard-drive",
				"code": "<line x1=\"22\" y1=\"12\" x2=\"2\" y2=\"12\"></line><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"></path><line x1=\"6\" y1=\"16\" x2=\"6\" y2=\"16\"></line><line x1=\"10\" y1=\"16\" x2=\"10\" y2=\"16\"></line>",
				"tags": [""]
			},
			{
				"name": "database",
				"code": "<ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\"></ellipse><path d=\"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3\"></path><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\"></path>",
				"tags": [""]
			},
			{
				"name": "phone",
				"code": "<path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>",
				"tags": [""]
			},
			{
				"name": "printer",
				"code": "<polyline points=\"6 9 6 2 18 2 18 9\"></polyline><path d=\"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2\"></path><rect x=\"6\" y=\"14\" width=\"12\" height=\"8\"></rect>",
				"tags": [""]
			},
			{
				"name": "server",
				"code": "<rect x=\"2\" y=\"2\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><rect x=\"2\" y=\"14\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><line x1=\"6\" y1=\"6\" x2=\"6.01\" y2=\"6\"></line><line x1=\"6\" y1=\"18\" x2=\"6.01\" y2=\"18\"></line>",
				"tags": [""]
			},
			{
				"name": "cpu",
				"code": "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\"></rect><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect><line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\"></line><line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\"></line><line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\"></line><line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\"></line><line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\"></line><line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\"></line><line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\"></line><line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\"></line>",
				"tags": ["computer", "cpu", "machine"]
			},
			{
				"name": "disc",
				"code": "<circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>",
				"tags": ["disc", "cd"]
			}]
		},

		{
			"title": "Social Media",
			"icons": [
			{
				"name": "facebook",
				"code": " <path d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\"></path>",
				"tags": ["facebook", "fb"]
			},
			{
				"name": "twitter",
				"code": "<path d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\"></path>",
				"tags": ["twitter", "bird"]
			}]
		},
		{
			"title": "Layout",
			"icons": [
			{
				"name": "layout",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M3 9h18M9 21V9\"/>",
				"tags": ["layout", "template", "grid", "header", "sidebar"]
			},
			{
				"name": "layout-2",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M3 9h18M15 21V9\"/>",
				"tags": ["layout", "template", "grid", "header", "sidebar"]
			},
			{
				"name": "layout-3",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M3 9h18\"/>",
				"tags": ["layout", "template", "grid", "header"]
			},
			{
				"name": "layout-4",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M3 15h18\"/>",
				"tags": ["layout", "template", "grid", "footer"]
			},
			{
				"name": "layout-5",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M9 3v18\"/>",
				"tags": ["layout", "template", "grid", "sidebar"]
			},
			{
				"name": "layout-6",
				"code": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><path d=\"M15 3v18\"/>",
				"tags": ["layout", "template", "grid", "sidebar"]
			}]
		}
	]
};

export default feathers